/* eslint-disable react/jsx-props-no-spreading */
import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon"
import { ReactElement } from "react"

import { ReactComponent as Admin } from "../../assets/admin-black.svg"
import { ReactComponent as Approvals } from "../../assets/approvals-2-black.svg"
import { ReactComponent as Attachment } from "../../assets/attachment-1-black.svg"
import { ReactComponent as AttachmentAdd } from "../../assets/attachment-2-black.svg"
import { ReactComponent as BatteryHalf } from "../../assets/battery-1-black.svg"
import { ReactComponent as Battery1Third } from "../../assets/battery-2-black.svg"
import { ReactComponent as Battery2Thirds } from "../../assets/battery-4-black.svg"
import { ReactComponent as BatteryEmpty } from "../../assets/battery-5-black.svg"
import { ReactComponent as Connections } from "../../assets/connections-black.svg"
import { ReactComponent as ConnectionsPeople } from "../../assets/connections-people-black.svg"
import { ReactComponent as Database } from "../../assets/database-black.svg"
import { ReactComponent as EVCharger } from "../../assets/ev-charger-black.svg"
import { ReactComponent as V2G } from "../../assets/ev-v2g-black.svg"
import { ReactComponent as HeatPump } from "../../assets/heat-pump-black.svg"
import { ReactComponent as SearchIconBase } from "../../assets/search-black.svg"
import { ReactComponent as SolarPanel } from "../../assets/solar-power-black-01.svg"

export const SolarPanelIcon = (props: SvgIconProps): ReactElement => (
    <SvgIcon {...props}>
        <SolarPanel />
    </SvgIcon>
)

export const BatteryHalfIcon = (props: SvgIconProps): ReactElement => (
    <SvgIcon {...props}>
        <BatteryHalf />
    </SvgIcon>
)

export const V2GIcon = (props: SvgIconProps): ReactElement => (
    <SvgIcon {...props}>
        <V2G />
    </SvgIcon>
)

export const Battery1ThirdIcon = (props: SvgIconProps): ReactElement => (
    <SvgIcon {...props}>
        <Battery1Third />
    </SvgIcon>
)

export const Battery2ThirdsIcon = (props: SvgIconProps): ReactElement => (
    <SvgIcon {...props}>
        <Battery2Thirds />
    </SvgIcon>
)

export const BatteryEmptyIcon = (props: SvgIconProps): ReactElement => (
    <SvgIcon {...props}>
        <BatteryEmpty />
    </SvgIcon>
)

export const EVChargerIcon = (props: SvgIconProps): ReactElement => (
    <SvgIcon {...props}>
        <EVCharger />
    </SvgIcon>
)

export const HeatPumpIcon = (props: SvgIconProps): ReactElement => (
    <SvgIcon {...props}>
        <HeatPump />
    </SvgIcon>
)

export const AdminIcon = (props: SvgIconProps): ReactElement => (
    <SvgIcon {...props}>
        <Admin />
    </SvgIcon>
)

export const ApprovalsIcon = (props: SvgIconProps): ReactElement => (
    <SvgIcon {...props}>
        <Approvals />
    </SvgIcon>
)

export const AttachmentIcon = (props: SvgIconProps): ReactElement => (
    <SvgIcon {...props}>
        <Attachment />
    </SvgIcon>
)

export const AttachmentAddIcon = (props: SvgIconProps): ReactElement => (
    <SvgIcon {...props}>
        <AttachmentAdd />
    </SvgIcon>
)

export const SearchIcon = (props: SvgIconProps): ReactElement => (
    <SvgIcon {...props}>
        <SearchIconBase />
    </SvgIcon>
)

export const ConnectionsIcon = (props: SvgIconProps): ReactElement => (
    <SvgIcon {...props}>
        <Connections />
    </SvgIcon>
)

export const DatabaseIcon = (props: SvgIconProps): ReactElement => (
    <SvgIcon {...props}>
        <Database />
    </SvgIcon>
)

export const ConnectionsPeopleIcon = (props: SvgIconProps): ReactElement => (
    <SvgIcon {...props}>
        <ConnectionsPeople />
    </SvgIcon>
)
